<template>
  <!-- <section id="testimonials" class="spacer"> -->
  <!-- <div class="title big">{{ testimonials.title }}</div> -->
  <div class="big">
    <div class="mbs">{{ item.quote }}</div>
    <div>{{ item.name }}</div>
  </div>
  <!-- </section> -->
</template>

<script>
import API from "@/api/service";
export default {
  data() {
    return {
      testimonials: [],
      item: [],
    };
  },
  created() {
    API.testimonials(this.$i18n.locale).then((page) => {
      this.testimonials = page.data.result;
      this.item = this.testimonials.children[
        Math.floor(Math.random() * this.testimonials.children.length)
      ];
    });
  },
};
</script>
